import {Header} from "../components/layout/header";
import {useGetCategories, useManageItems} from "../pages-lib/virtual-product-categories/model";
import React from "react";
import {useUpdateHeaderTitle, usePermission} from "../hooks";
import {ExtraButtons} from "../components/extra-buttons";
import styled from "styled-components";
import { Table as AntTable } from "antd"
import {EditDrawer, getColumns} from "../pages-lib/virtual-product-categories";
import {VisibilityProvider} from "../components/visibility-provider";

export default function VirtualProductCategories() {
    const [createDrawerState, setCreateDrawerState] = React.useState(false)
    const [editDrawerState, setEditDrawerState] = React.useState(false)
    const [duplicateCategoryInit, setDuplicateCategoryInit] = React.useState(null)

    function onSuccessEdit() {
        setEditDrawerState(!editDrawerState)
    }

    function onSuccessCreate() {
        setDuplicateCategoryInit(null)
        setCreateDrawerState(!createDrawerState)
    }

    function onCrateDuplicate(categoryId) {
        setDuplicateCategoryInit(categoryId)
        setCreateDrawerState(true)
    }

    const { dataCategories, refetch: getItems, handleTableChange, isLoading, pagination, options } = useGetCategories()

    const { hasPermission } = usePermission()

    const { editData, onSaveEdit, onCreate, onDelete, onEditItem } = useManageItems(dataCategories, getItems, onSuccessEdit, onSuccessCreate )

    const headerTitle = useUpdateHeaderTitle({
        items: dataCategories,
        defaultTitle: "0 Категорий",
        arrType: ["Категория", "Категории", "Категорий"],
    });

    const columns = getColumns(hasPermission("virtual-product-categories.edit") ? onEditItem : null, hasPermission("virtual-product-categories.delete") ? onDelete : null, onCrateDuplicate)

    return (
        <>
            <Header
                title={headerTitle}
                extra={
                    <ExtraButtons
                        onCreate={hasPermission("virtual-product-categories.create") ? () => setCreateDrawerState(true) : undefined}
                        // onFilter={() => setFilterDrawerState(!filterDrawerState)}
                        // onSort={() => setSortableDrawerState(!sortableDrawerState)}
                        titles={{ onCreate: "Добавить категорию" }}
                    />
                }
            />

            <StyledTable
                dataSource={dataCategories}
                pagination={pagination}
                loading={isLoading}
                onChange={handleTableChange}
                columns={columns}
            />

            {hasPermission("virtual-product-categories.create") && (
                <VisibilityProvider visible={createDrawerState}>
                    <EditDrawer
                        onSave={onCreate}
                        onClose={() => setCreateDrawerState(false)}
                        title={"Создание категории"}
                        initialValues={false}
                        categoryOptions={options.categoryOptions}
                        duplicateCategoryInit={duplicateCategoryInit}
                    />
                </VisibilityProvider>
            )}

            {hasPermission("virtual-product-categories.edit") && (
                <VisibilityProvider visible={editDrawerState}>
                    <EditDrawer
                        onSave={onSaveEdit}
                        onClose={() => setEditDrawerState(false)}
                        title={"Редактировании категории"}
                        categoryOptions={options.categoryOptions}
                        initialValues={editData}
                    />
                </VisibilityProvider>
            )}
        </>
    )
}

const StyledTable = styled(AntTable)`
  .row-can-view {
    cursor: pointer;
  }
`